/**
Project: Phone Connect (c)
Title: Request Util 
Description: Helper class with functions for Request 
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import api from "../helpers/api-services";
import TokenUtil from "./token-util";

class RequestUtil {
  // Set the Request Headers
  static setRequestHeaders() {
    api.defaults.baseURL = process.env.REACT_APP_UNIVERSAL_CONNECTER_API_URL;
    // api.defaults.headers.common['x-api-key'] = process.env.REACT_APP_API_KEY;
    api.defaults.headers.common["Content-Type"] = "application/json";
    api.defaults.headers.common["Accept"] =
      "application/json, text/plain, text/csv, application/octet-stream, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

    const sippioAccessToken = TokenUtil.getIdentitySippioAccessToken();
    if (sippioAccessToken) {
      // Apply authorization token to every request if logged in
      api.defaults.headers.common["Authorization"] = sippioAccessToken;
    } else {
      // Delete auth header
      delete api.defaults.headers.common["Authorization"];
    }

    /*
    api.defaults.baseURL =
      'https://97zn0qshi5.execute-api.us-east-2.amazonaws.com/dev/'; // process.env.REACT_APP_API_URL;

    api.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

    api.defaults.headers.common['Content-Type'] = 'application/json';
    api.defaults.headers.common['x-api-key'] =
      'bryjUflFDj8rWTA23DE2d9cGZVJi8jVf2jdTMiMk'; // process.env.REACT_APP_API_KEY;

    if (token) {
      // Apply authorization token to every request if logged in
      api.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
      // Delete auth header
      delete api.defaults.headers.common['Authorization'];
    }
    if (loginUser) {
      api.defaults.headers.common['Login-User'] = loginUser;
    } else {
      delete api.defaults.headers.common['Login-User'];
    }
    */
  }
}

export default RequestUtil;
